import ServiceHistory from 'src/components/ConnectedVehicle/ServiceHistory/ServiceHistory';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(ServiceHistory);